import $ from "jquery";
import _ from "lodash";
import ko from "knockout";
import IninAudioPlayer from "util/ininAudioPlayer";
import PubSub from "util/PubSub";
import userSettingsService from "services/userSettingsService";

//Constants declaration
const HTML5_AUDIO_TEMPLATE = "templates/widgets/audio/audioPlayerSetup";

const htmlAudioElements = [];

const updateAudioOutputs = function (data) {
    if (htmlAudioElements.length) {
        htmlAudioElements.forEach(function (element) {
            element.setSinkId(data.device.deviceId);
        });
    }
};

/**
 * This function executes after the template has been rendered. It will setup events
 * for the audioPlayer
 * @param {array} nodeArray - Array of HTML nodes that are added to the dom when rendering the template
 * @param (AudioPlayerView} audioPlayerView -  an instance of AudioPlayerView that is bound to the template
 */
const bindChannelsToAudioElements = function (nodeArray, audioPlayerView) {
    const $audioElements = $(".audio-elements", nodeArray);
    const $flashNode = nodeArray[2];

    PubSub.Topic("audio.device.changed").subscribe(updateAudioOutputs);

    userSettingsService.getSettings().then(function (settings) {
        _.each(audioPlayerView.audioChannels(), function (audioChannel, index) {
            if ($audioElements.length > index) {
                const $html5Node = $("audio", $audioElements[index]);
                const audioElement = $html5Node[0];
                htmlAudioElements.push(audioElement);

                let deviceId;
                try {
                    deviceId = settings.webrtc.defaultOutputDevice.deviceId;
                } catch (err) {
                    deviceId = null;
                }
                if (deviceId) {
                    audioElement.setSinkId(deviceId);
                }

                audioChannel.volumeControl.setDefaultVolume().then(function () {
                    const audioPlayer = new IninAudioPlayer();
                    audioPlayerView.init(
                        audioPlayer,
                        audioChannel,
                        $html5Node[0],
                        $flashNode,
                        index.toString()
                    );
                });

                $html5Node[0].addEventListener("error", function (e) {
                    // Pass audioUri to handleError for TTL expiry detection
                    audioPlayerView.handleError(e, {
                        audioUri: audioChannel?.audioUri,
                    });
                });
            }
        });
    });
};

const templateLoaded = ko.observable(false);

let templateToLoad = HTML5_AUDIO_TEMPLATE;

/**
 *  <p>html5 audio Binding Handler</p>
 *
 *  This binding will add the needed html5 markup and set events for the audio object
 *
 *  usage:  data-bind = "audioPlayerSetup: viewModel"
 *     Where viewModel is the audioPlayerView object"
 *
 */
ko.bindingHandlers.audioPlayerSetup = {
    init: function (element) {
        // include.loadTemplate(HTML5_AUDIO_TEMPLATE).then(function() {
        templateLoaded(true);
        // });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            PubSub.Topic("audio.device.changed").unsubscribe(
                updateAudioOutputs
            );
        });
    },
    update: function (element, valueAccessor) {
        const data = ko.unwrap(valueAccessor());

        if (data.forceFlash) {
            templateToLoad = HTML5_AUDIO_TEMPLATE;
        }

        if (templateLoaded() && data.audioChannels().length > 0) {
            ko.renderTemplate(
                templateToLoad,
                data,
                { afterRender: bindChannelsToAudioElements },
                element,
                "replaceNode"
            );
        }
    },
};
